var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup9260(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_49",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9260",
    "data-name": "Group 9260",
    transform: "translate(-1749 -956)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1749, 956)",
    filter: "url(#Ellipse_49)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49-2",
    "data-name": "Ellipse 49",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(9 6)",
    fill: "#00ca7d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "whatsapp",
    transform: "translate(1768.244 972.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3538",
    "data-name": "Path 3538",
    d: "M24.762,0H24.75A24.741,24.741,0,0,0,4.713,39.266l-3.085,9.2,9.516-3.042A24.752,24.752,0,1,0,24.762,0Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3539",
    "data-name": "Path 3539",
    d: "M136.058,140.724c-.6,1.687-2.968,3.085-4.858,3.494-1.294.275-2.983.5-8.671-1.863-7.275-3.014-11.96-10.407-12.325-10.887-.35-.48-2.94-3.915-2.94-7.467a7.9,7.9,0,0,1,2.531-6.025,3.6,3.6,0,0,1,2.531-.888c.306,0,.582.015.829.028.727.031,1.092.074,1.572,1.222.6,1.439,2.052,4.991,2.225,5.357a1.473,1.473,0,0,1,.105,1.34,4.278,4.278,0,0,1-.8,1.136c-.365.421-.712.743-1.077,1.194-.334.393-.712.814-.291,1.541a21.973,21.973,0,0,0,4.017,4.991,18.2,18.2,0,0,0,5.805,3.58,1.565,1.565,0,0,0,1.745-.275,29.956,29.956,0,0,0,1.934-2.562,1.382,1.382,0,0,1,1.776-.538c.668.232,4.205,1.98,4.933,2.343s1.207.538,1.383.845A6.165,6.165,0,0,1,136.058,140.724Z",
    transform: "translate(-96.891 -105.765)",
    fill: "#00ca7d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9260);
export default __webpack_public_path__ + "static/media/Group 9260.9a523369671417cdcb140c54461e03ba.svg";
export { ForwardRef as ReactComponent };